module.exports = __webpack_public_path__ + "img/search.22592175.svg";